import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7b54597b&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=7b54597b&prod&scoped=true&lang=css&"
import style2 from "./List.vue?vue&type=style&index=2&id=7b54597b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54597b",
  null
  
)

export default component.exports